import { IconPackId } from 'dragonmouse-shared/interfaces';
import { ICON_PACKS } from 'dragonmouse-shared/constants';
import { ICON_PACK_SVGS, IconData } from './iconSvgs';
import * as S from './styles';

interface IconPackSelectorProps {
	value: IconPackId;
	onChange: (iconPack: IconPackId) => void;
}

const renderIcon = (iconData: IconData, useFill: boolean = false, strokeWidth: number = 2) => {
	const viewBox = iconData.viewBox || '0 0 24 24';

	return (
		<S.InlineIcon viewBox={viewBox} $useFill={useFill} $strokeWidth={strokeWidth}>
			{iconData.paths?.map((d, i) => (
				<path key={`path-${i}`} d={d} />
			))}
			{iconData.circles?.map((circle, i) => (
				<circle key={`circle-${i}`} cx={circle.cx} cy={circle.cy} r={circle.r} />
			))}
			{iconData.polylines?.map((polyline, i) => (
				<polyline key={`polyline-${i}`} points={polyline.points} />
			))}
			{iconData.polygons?.map((polygon, i) => (
				<polygon key={`polygon-${i}`} points={polygon.points} />
			))}
			{iconData.lines?.map((line, i) => (
				<line key={`line-${i}`} x1={line.x1} y1={line.y1} x2={line.x2} y2={line.y2} />
			))}
			{iconData.rects?.map((rect, i) => (
				<rect
					key={`rect-${i}`}
					x={rect.x}
					y={rect.y}
					width={rect.width}
					height={rect.height}
					rx={rect.rx}
					ry={rect.ry}
				/>
			))}
		</S.InlineIcon>
	);
};

const IconPackSelector = ({ value, onChange }: IconPackSelectorProps) => {
	const iconPackIds = Object.keys(ICON_PACKS) as IconPackId[];

	return (
		<S.Base>
			{iconPackIds.map((packId) => {
				const isSelected = packId === value;
				const packIcons = ICON_PACK_SVGS[packId];

				return (
					<S.IconPill
						key={packId}
						type="button"
						$selected={isSelected}
						aria-pressed={isSelected}
						onClick={() => onChange(packId)}
					>
						<S.PackName $selected={isSelected}>{ICON_PACKS[packId].name}</S.PackName>
						<S.InlineIconsContainer $selected={isSelected}>
							{packIcons.icons.map((iconData, i) => (
								<div key={i}>
									{renderIcon(iconData, packIcons.useFill, packIcons.strokeWidth || 2)}
								</div>
							))}
						</S.InlineIconsContainer>
					</S.IconPill>
				);
			})}
		</S.Base>
	);
};

export default IconPackSelector;
